// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-swbl-ztxyLstd-index-main_right_content-ryIEg","table":"components-swbl-ztxyLstd-index-table-29RlI"};


//////////////////
// WEBPACK FOOTER
// ./components/swbl/ztxyLstd/index.css
// module id = 2301
// module chunks = 0